import { InputContainer } from './styles';
// EU01 EU02 EU06

export default InputContainer;
